/**
 * Route for `macro-library`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { MacroLibraryPage } from "../features/macro-library/MacroLibraryPage";

export const macroLibraryRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/macro-library",
	component: MacroLibraryPage,
});

export default macroLibraryRoute;
